export const removeSelectedArchitectures = (
  allArchitectures: Architecture[],
  selectedArchitectures: Architecture[],
): Architecture[] => {
  return allArchitectures.filter((arch) => {
    return selectedArchitectures.every((selected) => selected.uid !== arch.uid);
  });
};
